<template>
  <div>
    <v-alert type="info" v-if="!isLoading && !hasActiveCategories">
      {{ $t('CategoryInfo') }}
    </v-alert>
    <v-btn color="primary" class="mb-4" @click="newCategory">
      <span>{{ $t("Uusi palautetyyppi") }}</span>
    </v-btn>
    <v-simple-table v-if="categories.length">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('Palautetyypit') }}
            </th>
            <th class="text-center">
              {{ $t('Lomake') }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="!isLoading" :style="{ 'opacity': isLoading ? 0 : 1 }">
          <tr v-for="category in categories" :key="category.id">
            <td>
              <a @click="editCategory(category.id)">
                {{ category.title }}
              </a>
            </td>
            <td class="text-center">
              <v-chip v-if="category.has_form && category.use_form" x-small color="primary" outlined>
                {{ $t('Käytössä') }}
              </v-chip>
              <v-chip v-else-if="category.has_form && !category.use_form" x-small outlined>
                {{ $t('Ei käytössä') }}
              </v-chip>
              <span v-else class="grey--text">-</span>
            </td>
            <td>
              <v-icon v-if="category.is_active" size="24" color="success">{{ icons.mdiCheckboxMarkedCircle }}
              </v-icon>
              <v-icon v-else size="24" color="error">{{ icons.mdiCloseCircle }}
              </v-icon>
            </td>
          </tr>
        </tbody>
        <tbody v-if="isLoading">
          <tr>
            <td colspan="3" style="text-align: center">
              <br><br>
              <v-progress-circular indeterminate>
              </v-progress-circular>
              <br><br>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import useAuth from "@/useAuth";
import { useRouter } from "@core/utils";
import { computed, onMounted, ref } from "@vue/composition-api";
import { mdiCheck, mdiBlockHelper, mdiCheckboxMarkedCircle, mdiCloseCircle, mdiFormSelect } from "@mdi/js";
import adminApi from "@/api/admin";

export default {
  setup() {
    const { tenant } = useAuth();
    const { router } = useRouter();
    const categories = ref([]);
    const isLoading = ref(false);

    const getCategories = async () => {
      isLoading.value = true;
      const response = await adminApi.getFeedbackCategories();
      if (response.ok) {
        categories.value = response.data;
      } else {
        alert(response.error);
      }
      isLoading.value = false;
    };

    const editCategory = (id) => {
      router.push({ name: 'admin-feedback-category-form', params: { id: String(id) } });
    };

    const newCategory = () => {
      router.push({ name: 'admin-feedback-category-form' });
    };

    const hasActiveCategories = computed(() => {
      return categories.value.filter(a => a.is_active == true).length > 0;
    });

    onMounted(() => {
      getCategories();
    });

    return {
      categories,
      isLoading,
      newCategory,
      editCategory,
      hasActiveCategories,
      icons: {
        mdiBlockHelper,
        mdiCheckboxMarkedCircle,
        mdiCheck,
        mdiCloseCircle,
        mdiFormSelect
      }
    };
  },
};
</script>
